export default __webpack_public_path__ + "static/media/img_12.c85d52f1.jpg";